// export.js - 统一的 CSV 导出工具（Excel 可直接打开）

export function exportCSV(filename, headers, rows) {
	const esc = (v) => {
		v = String(v === null || v === undefined ? '' : v);
		if (/[",\n\r]/.test(v)) {
			v = '"' + v.replace(/"/g, '""') + '"';
		}
		return v;
	};
	const lines = [headers.map(esc).join(',')];
	rows.forEach((r) => lines.push(r.map(esc).join(',')));
	const blob = new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
	const a = document.createElement('a');
	a.href = URL.createObjectURL(blob);
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(a.href);
}
